// extracted by mini-css-extract-plugin
export default {"container":"TagPractices__container___mwsck","count":"TagPractices__count___m5kx5","footer":"TagPractices__footer___iDyCE","buttonContainer":"TagPractices__buttonContainer___oltPL"};